import React, { useEffect, useState } from 'react';
import { TiArrowSortedUp } from "react-icons/ti";
import { BASE_URL } from "../../../../../BaseUrl";
import { TiArrowSortedDown } from "react-icons/ti";
import Chart from "react-apexcharts";

const parseData = (data) => {
  return data
}
const chartData = {
  upward: [10, 15, 18, 21, 22, 23, 21, 25, 29],
  downward: [28, 24, 21, 22, 23, 24, 25, 19, 15, 10],
  linear: [10, 10, 10.05, 10.1, 10.12, 10.1, 10.05, 10, 9.95, 10, 10],
};

const CardsChartWidget = ({ data, heading, previous, isChart=false }) => {
  const [ cards, setCards ] = useState([]);

  useEffect(() => {
    data && setCards(parseData(data));
  }, [data,previous]);
  
  return (
    <div className="col col-12 row mx-0 mt-3 px-1">
      {heading
        ? <h4 className="mb-1">{heading}</h4>
        : ''
      }
      <div className='row mx-0 px-0 flex-wrap dashboard__card-container'>
        {cards.map((card,index) => {
          const isUp = Number(card.value) > Number(card?.previous);

          const data = isUp ? chartData.upward : ((card.value === card?.previous) ? chartData?.linear : (chartData.downward));

          const color = isUp ? "#19a464" : ((card.value === card?.previous) ? "#3B82F6" : "#e84040");

          // dynamic options per card
          const options = {
            chart: {
              type: "area",
              sparkline: {
                enabled: true,
              },
              toolbar: {
                show: false,
              },
            },

            stroke: {
              curve: "smooth",
              width: 2,
              colors: [color],
            },

            fill: {
              type: "gradient",
              gradient: {
                shade: "light",
                type: "horizontal",
                shadeIntensity: 0.8,
                opacityFrom: 0.5,
                opacityTo: 0.3,
                stops: [0, 70, 100],
              },
              colors: [color],
            },

            tooltip: {
              enabled: false,
            },

            dataLabels: {
              enabled: false,
            },

            grid: {
              show: false,
            },
          };

          const series = [
            {
              data: data,
            },
          ];
          
          return (
            <div key={index} className='col-3 p-0' >
              <div className='col p-0 flex-nowrap dashboard__card_view p-2' style={{margin:"0 0.4rem"}} >
                <div className='col m-0 p-0'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='text-capitalize font-weight-md fk-sm-card__title mb-0'>{card.name}</div>
                  </div>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-block'>
                      <p className='font-weight-bold xslg-text mb-0'>{card.value?.toLocaleString()}</p>
                      {(Object.hasOwn(card, "percent") || Object.hasOwn(card, "previous")) ? (
                          <div className='print-text d-flex align-items-center'>
                            <>
                              {card?.hasOwnProperty("percent") ? `${card?.percent}%` :
                              (isUp ? <span className='text-primary'><TiArrowSortedUp className="dashboard_card_up"/> {card?.previous > 0 ? (((card.value - card?.previous)/card?.previous)*100).toFixed(1) : 0 }% </span> : <span className='text-danger'><TiArrowSortedDown className="dashboard_card_down"/> {card.value > 0 ? (100 - ((card.value/card?.previous)*100)).toFixed(1) : 0 }% </span>)}
                            </>
                            {card?.["GP margin"] ? <span className='ml-2 card p-1 sm-text'>GP margin: {card["GP margin"]}</span> : ""}
                          </div>
                        ) : ""
                      }
                    </div>
                    {card?.image && <span className="ml-1 mr-0"><img style={{height:"2rem"}} src={BASE_URL + card.image} alt=""/></span>}
                  </div>
                </div>
                {isChart && chartData
                  ? (
                    <div className='col'>
                      <Chart
                        width="100%"
                        height={50}
                        options={options}
                        series={series}
                        type="area"
                      />
                    </div>
                  )
                  : ''
                }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CardsChartWidget